




import { Component, Mixins, Prop } from "vue-property-decorator";
import { LineKinds } from "../../domain/drawing";
import OptionDropDownSelector from "../system/selectors/OptionDropDownSelector.vue";
import { ModelEditableMixin, DisableableMixin } from "../system/mixins";
import { StandardOption } from "../system/selectors/mixins";

@Component({
  components: {
    selector: OptionDropDownSelector,
  },
})
export default class LineKindDropDownSelector extends Mixins(ModelEditableMixin, DisableableMixin) {
  @Prop({ default: false })
  isFigure: boolean;

  @Prop({ default: false })
  isArrow: boolean;
  
  get options(): any {
    if (this.isArrow) {
      return [
        new StandardOption<LineKinds>("通常", LineKinds.Normal),
      ];
    }
    if (this.isFigure) {
      return [
        new StandardOption<LineKinds>("通常", LineKinds.Normal),
        new StandardOption<LineKinds>("破線", LineKinds.Dotted),
      ];
    }
    return [
        new StandardOption<LineKinds>("通常", LineKinds.Normal),
        new StandardOption<LineKinds>("破線", LineKinds.Dotted),
        new StandardOption<LineKinds>("二重線", LineKinds.Double),
    ];
  }

  get isDisabled(): boolean {
    return this.options.length <= 1 || this.disabled;
  }
}
